import styled from "styled-components";
import * as CvCard from "components/cv-card/styles";
import queries, { maxQuery, devices } from "utils/responsivenessHelper";
import { Col } from "components/shared/layout";
import { Select } from 'antd';

const Container = styled(Col)`
  width: 100%;
  margin-top: 30px;

  ${queries.both({
    marginTop: 20,
  })}
`;

const CardTitleContainer = styled.div`
  display: contents;
`;

const Grid = styled.div`
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
  grid-template-areas: "summary summary";
  ${queries.both(
    {
      gridTemplateAreas: '"summary"',
      gridTemplateColumns: "repeat(auto-fill, minmax(100%, 1fr))",
    },
    devices.mobile
  )};
`;

const GridItem = styled.div`
  &:first-child {
    grid-column: 100%;
    grid-area: summary;
  }
  grid-column: 50%;
`;

const LevelSelect = styled(Select)`
  font-size: 20px;
  width: 120px;
  margin-right: 25px;
  float: right;

  ${queries.portrait(
    {
      marginTop: '10px',
      float: 'left'
    },
    devices.phone
  )}
`;

const CvCardWrapper = styled(Col)`
  padding: 25px;

  ${queries.portrait(
    {
      padding: "10px",
    },
    devices.phone
  )}

  ${CvCard.StyledCard} {
    height: 306px;
    min-width: 450px;
    margin: 0 auto;

    ${queries.both({
      minWidth: "100%",
      margin: "0 auto",
    })}
  }
`;

const ContentContainer = styled.div`
  width: 100%;
  padding: 65px;

  ${queries.both({
    padding: "5px",
  })}

  ${maxQuery.portrait(
    {
      padding: 0,
    },
    "320px"
  )}
`;

export { Container, CardTitleContainer, ContentContainer, CvCardWrapper, Grid, GridItem, LevelSelect };
